import React from "react";
// import { contact_type } from "./interfaces";
import { GoUnverified, GoVerified } from "react-icons/go";
const Contact = ({ contacts }) => {
  if (contacts && contacts.length > 0) {
    const mobile_contact =
      contacts.find(
        (p) =>
          p.contact_type === "mobile" && p.mark_primary === 1 && p.status === 1
      ) || contacts.find((p) => p.contact_type === "mobile" && p.status === 1);

    const email_contact =
      contacts.find(
        (p) =>
          p.contact_type === "email" && p.mark_primary === 1 && p.status === 1
      ) || contacts.find((p) => p.contact_type === "email" && p.status === 1);

    return (
      <>
        {mobile_contact && (
          <>
            Mobile :{" "}
            <strong>
              <a
                href={`tel:+91${mobile_contact?.contact_value}`}
                className="text-decoration-none"
              >
                {mobile_contact?.contact_value}&nbsp;
                {mobile_contact?.verified === 1 && (
                  <span className="text-success">
                    <GoVerified />
                  </span>
                )}
                {mobile_contact?.verified !== 1 && (
                  <span className="text-danger">
                    <GoUnverified />
                  </span>
                )}
              </a>
            </strong>
            <br />
          </>
        )}

        {email_contact && (
          <>
            Email :{" "}
            <strong>
              <a
                href={`mailto:${email_contact?.contact_value}`}
                className="text-decoration-none"
              >
                {email_contact?.contact_value}&nbsp;
                {email_contact?.verified === 1 && (
                  <span className="text-success">
                    <GoVerified />
                  </span>
                )}
                {email_contact?.verified !== 1 && (
                  <span className="text-danger">
                    <GoUnverified />
                  </span>
                )}
              </a>
            </strong>
            <br />
          </>
        )}
      </>
    );
  }
  return <></>;
};

export default Contact;
